module.exports = __webpack_public_path__ + "static/header_background-66c814bd22fef63d3d5118980d76c995.png";